import { FormSelectConfig } from '/@/modules/core/form/models/FormSelectConfig';
import Lang from '/@/modules/core/app/services/Lang';
import CountyService from '/@/modules/predefined/services/CountyService';

export class CountySelectConfig extends FormSelectConfig {
  constructor(config = {}) {
    super({
      placeholder: Lang.t('predefined.county'),
      label: 'name',
      trackBy: 'id',
      ...config
    });
  }

  /**
   * @returns {Array.<County>}
   */
  async getOptions(params = {}) {
    return CountyService.getEntities(params);
  }
}
